"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NUMBER_TEMPLATE = exports.SPECIFIER_TEMPLATE = void 0;
/* regexp to include specifiers like [{!$competitor1}] and
[{specifier}] with all symbols except curly bracket being optional */
exports.SPECIFIER_TEMPLATE = /\(?\[?\{!?(\$|\+|-)?\w+\d*\}\]?\)?\s?/gi;
/* Matches numbers inside odd names like: Over 22.5, Team2 (+5.5), Team1 (-5.5) etc */
exports.NUMBER_TEMPLATE = /\ ?\(?[-+]?\d+[.,:]?\d*\)?/;
//# sourceMappingURL=templates.js.map